import axios from "@/libs/api.request"

export const getConfoList = ({auth,userId}) => {
  const data = {userId}

  return axios.request({
    url:'api/20211012/infs/getConfoList.json',
    //开发环境
    method:'post',
    data,
    headers:{'Authorization':auth}
  })
}

export const cameraTree = ({auth,userId,search}) => {
  const data = {userId,search}

  return axios.request({
    url:'api/api-v2.2.3/cameraTree.json',
    //开发环境
    method:'post',
    data,
    headers:{'Authorization':auth}
  })
}

//地图设置
export const getMapDefaultSet = () => {
  return axios.request({
    url: 'api/map/find',
    method: 'get',
  })
}

//229

/**
 * 查询场景图
 * @param form
 * @returns {*}
 */
export const querySelfMap = (form) => {
  const params = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/query',
    params,
    method:'get'
  })
}

/**
 * 添加场景图
 * @param form
 * @returns {*}
 */
export const addSelfMap = (data) =>{
  return axios.request({
    url:'system-service/api-v2.0/map/add',
    data,
    method:'post',
    contentType:false,
    processData:false
  })
}

/**
 * 更新场景图
 * @param form
 * @returns {*}
 */
export const updateSelfMap = (form) => {
  const data = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/update',
    data,
    method:'post'
  })
}

/**
 * 查询地图上的点
 * @param form
 * @returns {*}
 */
export const queryPoint = (form) => {
  const params = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/point/query',
    params,
    method:'get'
  })
}

/**
 * 查询单个点
 * @param form
 * @returns {*}
 */
export const queryPointDetail = (form) => {
  const params = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/point/query/detail',
    params,
    method:'get'
  })

}

/**
 * 新增地图上的点
 * @param form
 * @returns {*}
 */
export const addPoint = (form) => {
  const data = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/point/add',
    data,
    method:'post'
  })
}

/**
 * 更新地图上的点
 * @param form
 * @returns {*}
 */
export const updatePoint = (form) =>{
  const data = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/point/update',
    data,
    method:'post'
  })
}

/**
 * 删除地图上的点
 * @param form
 * @returns {*}
 */
export const deletePoint = (form) => {
  const data = form
  return axios.request({
    url:'system-service/api-v2.0/map/point/delete',
    data,
    method:'post'
  })
}

/**
 * 搜索终端
 * @param form
 */
export const searchPoint = (form) => {
  const params = {...form}
  return axios.request({
    url: 'system-service/api-v2.0/map/point/search',
    method: 'get',
    params
  })
}

/**
 * 添加电子围栏
 * @param form
 * @returns {*}
 */
export const addFence = (form) => {
  const data = {...form}
  return axios.request({
    url: 'system-service/api-v2.0/map/fence/add',
    data,
    method:'post'
  })
}

/**
 * 编辑电子围栏
 * @param form
 * @returns {*}
 */
export const updateFence = (form) => {
  const data = {...form}
  return axios.request({
    url: 'system-service/api-v2.0/map/fence/update',
    data,
    method:'post'
  })
}

/**
 * 删除电子围栏
 * @param form
 * @returns {*}
 */
export const deleteFence = (form) => {
  const data = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/fence/delete',
    data,
    method:'post'
  })
}

/**
 * 查询所有电子围栏
 */
export const queryFences = () =>{
  return axios.request({
    url: 'system-service/api-v2.0/map/fence/query/all',
    method: 'get'
  })
}

/**
 * 查询具体的电子围栏
 * @param form
 */
export const queryFenceDetail = (form) => {
  const params = {...form}
  return axios.request({
    url: 'system-service/api-v2.0/map/fence/query/detail',
    method: 'get',
    params
  })
}

/**
 * 查询所有报警信息
 * @param form
 */
export const queryFenceWarnings = (form) => {
  const data = {...form}
  return axios.request({
    url: 'system-service/api-v2.0/map/fence/warning/query',
    method: 'post',
    data
  })
}

/**
 * 查询所有APP用户
 * @param form
 */
export const queryAllAppUser = (form) => {
  const params = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/fence/all/user',
    method:'get',
    params
  })
}

/**
 * 获取轨迹的所有点
 * @param form
 * @returns {*}
 */
export const queryTravelPoints = (form) => {
  const data = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/travel',
    data,
    method:'post'
  })
}

/**
 * 编辑地图显示的终端树
 * @param form
 */
export const queryEditDevicesTree = (form) => {
  const params = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/point/tree/edit',
    params,
    method:'get'
  })
}

/**
 * 正常显示下的已存在终端树
 * @param form
 */
export const queryShowDevicesTree = (form) => {
  const params = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/point/tree/show',
    params,
    method:'get'
  })
}

/**
 * 查询是否存在转流的场景图进程
 * @param form
 * @returns {*}
 */
export const queryTransfer = (form) => {
  const params = {...form}
  return axios.request({
    url:'system-service/api-v2.0/map/transfer',
    params,
    method:'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/map.js